





























































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  CruiseTrackData, CruiseTrackDetailData, emptyCruiseTrack, getInfo
} from '@/api/heritageCruise/cruiseTrack'
import UnitMap from '@/components/unitMap/index.vue'
import { UnitPositionMapData, CheckPointData } from '@/api/common/mapData'

@Component({
  components: { UnitMap }
})
export default class CruiseTrackForm extends Vue {
  // dynamic component
  public $refs!: {
    formData: Element.Form
    refUnitMap: UnitMap
  }
  public collapseNames = ['details']
  public form: CruiseTrackData = Object.assign({}, emptyCruiseTrack)
  public loading: boolean = true

  public fetchMap() {
    const f = this.form
    const mapData: {
      checkPoint: CheckPointData
      positions: UnitPositionMapData[]
      tracks: CruiseTrackDetailData[]
      obj: any
    } = {
      checkPoint: new CheckPointData(),
      positions: this.form.UnitPositionAreas,
      tracks: f.DetailList,
      obj: { unitName: f.UnitName }
    }
    if (this.$refs.refUnitMap) {
      this.$refs.refUnitMap.loadData(mapData)
    }
    // window.eventBus.$emit('loadUnitMap', mapData)
  }
  public created() { }
  public mounted() {
    this.fetchData()
  }
  public fetchTrack(id: number) {
    this.loading = true
    getInfo(id).then((response: { data: any }) => {
      if (response.data) {
        this.form = response.data
        this.fetchMap()
        this.loading = false
      }
    })
  }
  public fetchData() {
    const id = +this.$router.currentRoute.params.id || 0
    this.fetchTrack(id)
  }
  public onCancel() {
    this.$router.push({ path: `/CruiseTrack` }).catch((data: any) => {
      console.log(this.$route.path, data)
    })
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
